import React from 'react'
import './hero.scss'
import { graphql, useStaticQuery } from 'gatsby'
import {GatsbyImage, getImage} from "gatsby-plugin-image";

export default Hero => {
  const data = useStaticQuery(graphql`
    query {
      fourOFour: file(relativePath: { eq: "AL-404.png" }) {
        childImageSharp {
          gatsbyImageData(width: 333)
        }
      }
    }
  `)

  const image = getImage(data.fourOFour.childImageSharp)

  return (
    <div>
      <GatsbyImage image={image} alt="Sorry, not found"/>
      <h2 className="light">Sorry that page could not be found.</h2>
      <hr />
      <p>Maybe check the links below to find what you were looking for.</p>
    </div>
  )
}
